import { useMemo } from 'react';
import { useQueryUsersBasic } from './userActions';
import { filterAssignableUsers } from './userRoleFiltering';

export const useAssignableUsers = () => {
  const { data: users, isLoading } = useQueryUsersBasic();

  const assignableUsers = useMemo(() => {
    return filterAssignableUsers(users);
  }, [users]);

  return {
    assignableUsers,
    isLoading,
  };
};
